import { themeGet } from '@styled-system/theme-get';
import styled, { css } from 'styled-components/macro';

import { Relative } from '@olist/united';

const centerBase = css`
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
`;

const Circles = styled(Relative)`
  align-items: center;
  background-color: ${({ color }) => `${color}4d`};
  border-radius: ${themeGet('olist.borderRadius.circle')};
  display: flex;
  height: 56px;
  justify-content: center;
  width: 56px;

  svg {
    position: relative;
    z-index: 1;
  }

  &:before {
    background-color: ${({ color }) => `${color}80`};
    border-radius: ${themeGet('olist.borderRadius.circle')};
    content: '';
    height: 48px;
    width: 48px;
    ${centerBase}
  }

  &:after {
    background-color: ${({ color }) => color};
    border-radius: ${themeGet('olist.borderRadius.circle')};
    content: '';
    height: 40px;
    width: 40px;
    ${centerBase}
  }
`;

export default Circles;
